// extracted by mini-css-extract-plugin
module.exports = {"formActions":"appointments__SearchForm__formActions"};